import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext({ lang: 'en', toggleLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('tw-lang') || 'en');

  const toggleLang = () => {
    const next = lang === 'en' ? 'pt' : 'en';
    setLang(next);
    localStorage.setItem('tw-lang', next);
  };

  return (
    <LanguageContext.Provider value={{ lang, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
